import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { apiService } from "../../constants/ApiService";
import { useNavigate } from "react-router-dom";

const BlogsSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 992,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 576,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  const navigate = useNavigate();

  const blogs = [
    {
      title: "5 Must-Have Scents for Every Mood",
      description:
        "Discover the perfect fragrance for every emotion and occasion. From uplifting citrus to sensual oud, find your signature scent.",
      image: "../assets/images/perfume/pexels1.jpg",
      link: "/blogs/must-have-scents",
    },
    {
      title: "Why Affordable Luxury is the Future",
      description:
        "Gone are the days when luxury meant overpriced. Learn why affordable premium perfumes are redefining elegance.",
      image: "../assets/images/perfume/pexels2.jpg",
      link: "/blogs/affordable-luxury",
    },
    {
      title: "Behind the Notes: How Valorelle Creates Fragrances",
      description:
        "Peek into our perfume lab and learn how each note is blended to perfection by our in-house experts.",
      image: "../assets/images/perfume/pexels3.jpg",
      link: "/blogs/behind-the-notes",
    },
  ];

  const [blogTable, setBlogTable] = useState([]);
    const getBlogData = async (page = 1, limit = 10, search = "") => {
      try {
        let config = {
          headers: {
            'Content-Type': 'application/json', // Important for file upload//s
            'accept': 'application/json'
          }
        };
  
        const response = await apiService.get(`/api/BlogMaster/allblog?pageNo=${page}&limit=${limit}&searchKey=${search}`, config)
        if (response.response && response.response.data.errors) {
          console.log(response.response?.data?.errors)
        }
  
        if (response.status === true) {
          console.log(response.blogMasterData)
          setBlogTable(response.blogMasterData)
          // console.log(response.message);
        }
        else {
          console.log(response.message);
        }
      } catch (error) {
        console.log(error)
        alert('SomeThing went wrong!!');
      }
    };
  
    useEffect(() => {
      getBlogData();
    }, [!blogTable]);
  
    const goBlogDetail = (blogId) => {
      navigate('/blogdetail', { state: { blogId: blogId } });
    }


    const stripHtml = (html) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
        return tempDiv.textContent || tempDiv.innerText || "";
      };

  return (
    <>
    
    <style>
        {`
        .elegant-box {
  transition: all 0.3s ease;  
}

        .elegant-box:hover {
  transform: translateY(-5px);
}


        `}
    </style>
    <section className="blog-section section-lg-space" style={{ backgroundColor: "transparent" }}>
      <div className="container-fluid">
        <div className="about-us-title text-center">
          <h3 className="inter-font text-white">Our Blog</h3>
          <h2 className="center text-white">Latest Stories & Insights</h2>
        </div>
        <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
          <div className="col-12">
            <Slider {...settings} className="slider-4-half product-wrapper">
              {blogTable.map((data, index) => (
                <div key={index}>
                <div
                onClick={() => { goBlogDetail(data.id) }} 
                  className="blog-box mx-3 bg-white fadein"
                  style={{
                    cursor:"pointer",
                    border: "1px solid #eaeaea",
                    borderColor: "#c2a57c",
                    borderRadius: "8px",
                    overflow: "hidden",
                    height: "100%", // Important for flex container
                    display: "flex",
                    flexDirection: "column",
                    minHeight: "410px", // Fix height for consistency
                    maxHeight: "410px", // Prevent overflow
                  }}
                >
                  <img
                    src={process.env.REACT_APP_API_BASE_URL +data.img_url}
                    alt={data.blog_title}
                    style={{
                      width: "100%",
                      height: "200px",
                      objectFit: "cover",
                    }}
                  />
                  <div
                    style={{
                      padding: "15px",
                      display: "flex",
                      flexDirection: "column",
                      flexGrow: 1,
                    }}
                  >
                    <h4 className="fw-bold inter-font text-theme" style={{ fontSize: 16, marginBottom: 6 }}>
                    {data.blog_title}
                    </h4>
              
                    {/* Description trimmed if too long */}
                    <p style={{
                      color: "#555",
                      flexGrow: 1,
                      overflow: "hidden",
                      display: "-webkit-box",
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: "vertical",
                    }} className="inter-font">
                      {stripHtml(data.blog_content)}
                    </p>
              
                    <a onClick={() => { goBlogDetail(data.id) }} className="btn btn-sm theme-bg-color text-white mt-2 align-self-end inter-font">
                      Read More
                    </a>
                  </div>
                </div>
              </div>
              
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default BlogsSlider;
